import type { ImageData } from '@beat-venues/common-types';
import { ContentfulContentImage } from '@beat-venues/contentful-image';
import { type VariantProps, tv } from 'tailwind-variants';

import { Button } from '../../atoms';
import type { CommonProps } from '../../types';

import type { JSX } from 'react';

export interface ContentBannerProps
    extends CommonProps,
        VariantProps<typeof ContentBannerStyles> {
    image: ImageData;
    label: string;
}

export const ContentBannerStyles = tv({
    slots: {
        root: 'click-area overflow-hidden rounded-md group w-fit focus',
        buttonWrapper:
            'z-20 peer absolute flex items-end justify-end p-6 w-full h-full',
        button: 'click-area-link self-end',
        imageWrapper: 'group relative z-0',
        image: 'transition group-hover:scale-105 peer-focus:group-[]:scale-105',
    },
    variants: {
        hideCta: {
            true: {
                button: 'opacity-0',
            },
            false: {
                button: '',
            },
        },
    },
    defaultVariants: {
        hideCta: false,
    },
});

export const ContentBanner = ({
    className,
    image,
    label,
    hideCta,
    testId = 'content-banner',
    ...props
}: ContentBannerProps): JSX.Element => {
    const {
        root,
        button,
        image: imageStyles,
        imageWrapper,
        buttonWrapper,
    } = ContentBannerStyles();
    return (
        <div className={root({ className })}>
            <div className={buttonWrapper()}>
                <Button className={button({ hideCta })} {...props}>
                    {label}
                </Button>
            </div>
            <ContentfulContentImage
                className={imageStyles()}
                data={image}
                rounded="none"
                showCaption={false}
                wrapperClassName={imageWrapper()}
            />
        </div>
    );
};
